import { pxToRem } from '../../utils'
import Button from './Button'
import { ButtonLoader } from '../Cabinet'
import React from 'react'
import styled from 'styled-components'

const Wrapper = styled(Button)`
  width: ${pxToRem(230)};
  height: ${pxToRem(40)};
  margin-left: auto;
  position: relative;
`

const ReloadButton = props => {
  const { loading = false, children, ...rest } = props

  return (
    <Wrapper disabled={loading} {...rest}>
      {loading ? <ButtonLoader /> : children }
    </Wrapper>
  )
}

export default ReloadButton



// WEBPACK FOOTER //
// ./src/components/Form/DownloadButton.js